import Alpine from 'alpinejs/dist/module.cjs'
const data = (params = {}) => ({
  // movement of scrolling button to the left and to the right
  moveLeft() {
    if (this.currentPositionIndex <= 0) {
      return
    }

    this.currentPositionIndex = Math.max(0, this.currentPositionIndex - 5)
    this.scrollToCurrentPosition()
  },

  moveRight() {
    if (this.currentPositionIndex >= this.totalColumns - 5) {
      return
    }

    this.currentPositionIndex = Math.min(
      this.totalColumns - 5,
      this.currentPositionIndex + 5
    )
    this.scrollToCurrentPosition()
  },

  // display scroll left and right button
  isFixed: false,
  enabledMove: true,
  isPC: window.innerWidth >= 768,

  get showLeftButton() {
    return this.enabledMove && this.isPC && this.currentPositionIndex > 0
  },

  get showRightButton() {
    return (
      this.enabledMove &&
      this.isPC &&
      this.currentPositionIndex < this.totalColumns - 5
    )
  },

  // fixedScrollArea
  fixedContentHeight: '',
  fixedContentLeft: '',
  currentPositionIndex: 0,

  scrollToCurrentPosition() {
    this.$root.querySelector('[x-ref="tableScrollArea"]').scrollTo({
      left: this.viewWidths,
      behavior: 'smooth',
    })
    this.$root.querySelector('[x-ref="fixedScrollArea"]').scrollTo({
      left: this.viewWidths,
      behavior: 'smooth',
    })
  },

  get totalColumns() {
    if (this.syncEnableFilter) {
      return this.checkedItems.filter((v) => v).length
    } else {
      return this.allColumns.length
    }
  },

  get viewWidths() {
    return [...this.allColumns]
      .filter((v) => v.style.display !== 'none')
      .slice(0, this.currentPositionIndex)
      .reduce(
        (accumulator, currentValue) => accumulator + currentValue.offsetWidth,
        0
      )
  },

  // synchronous scroll of fixedScrollArea and tableScrollArea
  allColumns: [],
  checkedItems: [],
  syncEnableFilter: false,

  init() {
    this.allColumns = this.$root.querySelectorAll(
      '[x-ref="tableScrollArea"] tr:first-child > td'
    )
    this.setupSyncScroll()
  },

  setupSyncScroll() {
    let ignoreScrollEvents = false

    const syncScroll = (scrollingElement, syncScrollElement) => {
      scrollingElement.addEventListener('scroll', (e) => {
        if (window.innerWidth >= 768) return

        const ignore = ignoreScrollEvents
        ignoreScrollEvents = false

        if (ignore) return

        ignoreScrollEvents = true
        syncScrollElement.scrollLeft = scrollingElement.scrollLeft
      })
    }

    const tableScrollArea = this.$root.querySelector(
      '[x-ref="tableScrollArea"]'
    )
    const fixedScrollArea = this.$root.querySelector(
      '[x-ref="fixedScrollArea"]'
    )

    syncScroll(tableScrollArea, fixedScrollArea)
    syncScroll(fixedScrollArea, tableScrollArea)
  },

  ...params,
})

Alpine.data('simulationDisplay', data)
